module.exports = __webpack_public_path__ + "img/bg.b7b8bace.jpg";